angular.module("ainapp")
    .controller("LoginController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.basePath = config.basePath;
            $scope.FinYear = [];
            MainService.FinYearInDropDown().then(function (response) {
                $scope.FinYear = response.data;
            });

            $scope.Init = function () {
                $scope.TokenInfo = AuthenticationService.getTokenInfo();
                $scope.Language = "EN";

                if ($scope.TokenInfo != null) {
                    $scope.IsLoggedIn = true;
                } else {
                    $scope.IsLoggedIn = false;
                }

                $scope.User = {
                    UserName: "",
                    Password: "",
                    FinancialYearId: "",
                    OTP: "",
                }

                $scope.load = true;
                $scope.CompanyProfile = {};
                MainService.GetCompanyProfile().then(function (response) {
                    if (response.data != null) {
                        $scope.CompanyProfile = response.data;
                        $scope.User.FinancialYearId = $scope.CompanyProfile.DefaultFinancialYearId;
                    }
                    $scope.load = false;
                }, function (err) {
                    $scope.load = false;
                });

                $scope.View = 0;

            }
            $scope.Init();


            $scope.Login = function () {

                $scope.loginError = false;
                $scope.IsLoggedIn = false;
                if ($scope.User.UserName == "") {
                    $scope.loginError = true;
                } else if ($scope.User.FinancialYearId == "" && $scope.User.UserName != 'ainsoft') {
                    $scope.loginError = true;
                } else if ($scope.User.Password == "" || $scope.User.Password == undefined) {
                    $scope.loginError = true;
                } else {
                    $scope.load = true;
                    LoginService.Login($scope.User)
                        .then(function (response) {
                            $scope.load = false;
                            if (response.data != null && response.data != "") {

                                if ($scope.CompanyProfile.IsBranch) {

                                    $scope.TokenInfo = response.data;
                                    $scope.TokenInfo.FinancialYearId = $scope.User.FinancialYearId;
                                    $scope.loginError = false;

                                    $scope.load = true;
                                    MainService.BranchesInDropdown().then(function (response) {
                                        $scope.load = false;
                                        if (response.data) {
                                            $scope.Branches = response.data;
                                            $scope.View = 1;
                                        } else {
                                            toastr.error("Network Error");
                                        }
                                    }, function (err) {
                                        toastr.error("Network Error");
                                        $scope.load = false;
                                    })

                                } else {

                                    $scope.TokenInfo = response.data;
                                    $scope.TokenInfo.FinancialYearId = $scope.User.FinancialYearId;
                                    $scope.loginError = false;
                                    $scope.IsLoggedIn = true;
                                    AuthenticationService.setTokenInfo($scope.TokenInfo);
                                    $scope.Init();
                                    $state.go("home");

                                }

                            } else {
                                $scope.IsLoggedIn = false;
                                $scope.loginError = true;
                            }
                        }, function (err) {
                            $scope.load = false;
                            $scope.loginError = true;
                        });
                }
            };

            $scope.CheckOtp = function () {
                if ($scope.User.OTP == "") {
                    toastr.warning("Enter OTP");
                } else if ($scope.User.OTP.toString().length != 6) {
                    toastr.warning("Enter Valid OTP");
                } else {
                    $scope.load = true;
                    MainService.checkLoginOTP($scope.User.OTP).then(function (response) {
                        $scope.load = false;
                        if (response.data) {
                            toastr.success("Successfully Validated");

                            $scope.IsLoggedIn = true;
                            AuthenticationService.setTokenInfo($scope.TokenInfo);
                            $scope.Init();
                            $state.go("home");
                        } else {
                            toastr.error("Network Error");
                        }
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = false;
                    })
                }
            }

            $scope.chooseBranch = function (branch) {

                if (branch == 0) {
                    branch = {
                        Id: 0,
                        Name: "All"
                    }
                }

                $scope.TokenInfo.BranchId = branch.Id;
                $scope.TokenInfo.BranchName = branch.Name;

                MainService.UpdateBranchUserSession($scope.TokenInfo).then(function (response) {
                    if (response.data) {
                        $scope.IsLoggedIn = true;
                        AuthenticationService.setTokenInfo($scope.TokenInfo);
                        $scope.Init();
                        $state.go("home");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                }, function (err) {
                    $scope.load = false;
                    toastr.error("Network Error");
                });



            }

            /////////////// logout  ////////////// 
            //
            //            $scope.logOut = function () {
            //                $scope.working = true;
            //                LoginService.logOut()
            //                    .then(function (response) {
            //                        $scope.working = false;
            //                        if (response) {
            //                            AuthenticationService.removeTokenInfo();
            //                            $scope.IsLoggedIn = false;
            //                            $scope.Init();
            //                            $state.go("home");
            //                        }
            //                    }, function (err) {
            //                        $scope.working = false;
            //                    })
            //            };


      }]);
